module.exports = __webpack_public_path__ + "static/media/building.856ca804.jpg";